export function getTheme(theme, themes) {
  switch (theme) {
    case "theme-vimelco":
      return themes["vimelco"];
    case "theme-sm":
      return themes["sm"];
    case "theme-nf":
      return themes["nf"];
    case "theme-polymetal":
      return themes["polymetal"];
    case "theme-global":
      return themes["global"];
    case "theme-ugmk":
      return themes["ugmk"];
    case "theme-item":
      return themes["item"];
    default:
      return themes["light"];
  }
}
